import React from 'react';
import { Modal, Button } from '@whalecloud/fdx';
import { i18n } from 'fishx';

export function successAlert(props = {}) {
  const {
    title = i18n('COMMON_ALERT_SUCCESS'),
    content = i18n('COMMON_ALERT_SUCCESS_TEXT'),
    btnText = i18n('COMMON_ALREADY_KNOW'),
    callbackFunc = () => {},
    loading = false,
    ...propsForModal
  } = props;
  const modal = Modal.info({
    content: (
      <>
        <span className="iconfont2 iconcir-check-circle-fill" />
        <h3>{title}</h3>
        <p>{content}</p>
        <Button type="primary" loading={loading} onClick={() => { modal.destroy(); callbackFunc(); }}>{btnText}</Button>
      </>
    ),
    okButtonProps: {
      disabled: true,
    },
    className: 'alartWarp successAlartWarp',
    ...propsForModal,
  });
}

export function failAlert(props = {}) {
  const {
    title = i18n('COMMON_ALERT_FAILURE'),
    content = i18n('COMMON_ALERT_FAILURE_TEXT'),
    btnText = i18n('COMMON_ALREADY_KNOW'),
    callbackFunc = () => {},
    ...propsForModal
  } = props;
  const modal = Modal.info({
    content: (
      <>
        <span className="iconfont2 iconcir-info-circle-fill" />
        <h3>{title}</h3>
        <p>{content}</p>
        <Button type="primary" onClick={() => { modal.destroy(); callbackFunc(); }}>{btnText}</Button>
      </>
    ),
    okButtonProps: {
      disabled: true,
    },
    className: 'alartWarp failureAlartWarp',
    ...propsForModal,
  });
}

export function confirmAlert(props = {}) {
  const {
    title = i18n('COMMON_SURE_SUBMIT_TITLE'),
    content = i18n('COMMON_SURE_SUBMIT_TEXT'),
    cancelBtnText = i18n('COMMON_CANCEL'),
    okBtnText = i18n('COMMON_CONFIRM'),
    callbackFunc = () => {},
    ...propsForModal
  } = props;
  const modal = Modal.info({
    content: (
      <>
        <h3>{title}</h3>
        <p>{content}</p>
        <footer>
          <Button onClick={() => { modal.destroy(); }}>{cancelBtnText}</Button>
          <Button type="primary" onClick={() => { modal.destroy(); callbackFunc(); }}>{okBtnText}</Button>
        </footer>
      </>
    ),
    okButtonProps: {
      disabled: true,
    },
    className: 'alartWarp confirmAlartWarp',
    ...propsForModal,
  });
}
